import type { PropType } from "vue";

// Types
import type {
  IProvisionProviderData,
  IProvisionProviderMethods
} from "@/models/providers/provisioning";

export default {
  inject: {
    $provisionProviderData: {
      type: Object as PropType<IProvisionProviderData>,
      from: "provisionProviderData"
    },
    $provisionMethods: {
      type: Object as PropType<IProvisionProviderMethods>,
      from: "provisionProviderMethods"
    }
  },
  computed: {
    $provisionData(): IProvisionProviderData {
      return this.$provisionProviderData();
    }
  }
};
